import React, { useCallback, useRef } from 'react';
import { RemovePromoIcon } from '../../../Icons';
import { PromoCookie } from '../../../../models';

import './PromoElement.css';
import { Config } from '../../../../helpers/config';
import {
  getFromLocalStorage,
  setOnLocalStorage,
  StorageKey,
} from '../../../../helpers/localstorage';
import { ModalRef } from '../../../Modal/Modal';
import { PromoDetailsModal } from '../PromoDetailsModal/PromoDetailsModal';

type PromoCookieElementProps = {
  promoCookie: PromoCookie;
  onBannerRemoved: () => void;
  orderId?: string | null;
};

export const PromoCookieElement: React.FC<PromoCookieElementProps> = ({
  promoCookie,
  orderId,
  onBannerRemoved,
}) => {
  const removePromoBanner = useCallback(() => {
    const promoCookies: string[] = getFromLocalStorage(
      StorageKey.RemovedPromoCookies
    );
    setOnLocalStorage(
      promoCookies
        ? [...promoCookies, `${promoCookie.id}:${orderId}`]
        : [`${promoCookie.id}:${orderId}`],
      StorageKey.RemovedPromoCookies
    );
    onBannerRemoved();
  }, [onBannerRemoved, promoCookie.id, orderId]);

  const promoDetailsModalRef = useRef<ModalRef>(null);

  const openModal = useCallback(() => {
    promoDetailsModalRef.current?.openModal();
  }, []);

  function prefixImageUrlIfNecessary(url = '') {
    return url.startsWith('https://') || url.startsWith('http://')
      ? url
      : `${Config.baseCmsUrl}${url}`;
  }
  return (
    <>
      <div className="promo-element--card" onClick={openModal}>
        <img
          className="promo-element--image"
          src={`${prefixImageUrlIfNecessary(promoCookie.image.url)}`}
        />
        <div className="promo-element--text-container">
          <h3 className="promo-element--title">{promoCookie.title}</h3>
          <p className="promo-element--description">
            {promoCookie.description}
          </p>
        </div>
        <button
          onClick={removePromoBanner}
          className="promo-element--remove-button"
        >
          <RemovePromoIcon />
        </button>
      </div>
      <PromoDetailsModal
        image={`${promoCookie?.largeImage?.url ? prefixImageUrlIfNecessary(promoCookie.largeImage.url) : prefixImageUrlIfNecessary(promoCookie.image.url)}`}
        title={promoCookie.title}
        description={promoCookie.description}
        ref={promoDetailsModalRef}
      />
    </>
  );
};
